import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Beat } from "../../../../plugins/spinners.plugin";
import Button from "../../../../components/buttons/buttons";
import TransferOutlet from "./TransferOutlet";
import TransferBusiness from "./TransferBusiness";
import { transferRestaurantAction } from "../../../../redux/restaurant/restaurantActions";
import { transferStore } from "../../../../redux/stores/storeActions";

export default function TransferOwnership() {
  const dispatch = useDispatch();
  const [mobileView, setMobileview] = useState("outlet-side");
  const [outletType, setOutletType] = useState("");
  const [selectedoutlet, setSelectedOutlet] = useState({});
  const [selectedBusiness, setSelectedBusiness] = useState({});
  const [businessName, setBusinessName] = useState("");
  const [businessDetails, setBusinessDetails] = useState({});
  const [restaurantName, setRestaurantName] = useState("");
  const [storeName, setStoreName] = useState("");

  const { transferringRestaurant } = useSelector((state) => state.restaurant);
  const { transferringStore } = useSelector((state) => state.store);

  const handleTransferRestaurant = async () => {
    try {
      await dispatch(
        transferRestaurantAction({
          id: selectedoutlet?.id,
          business_id: selectedBusiness?.id,
        })
      );
    } catch (error) {}
  };

  const handleTransferStore = async () => {
    try {
      await dispatch(
        transferStore({
          id: selectedoutlet?.id,
          business_id: selectedBusiness?.id,
        })
      );
    } catch (error) {}
  };
  return (
    <div>
      {/* This view is strictly mobile view */}
      <div className="block sm:hidden grid grid-cols-1 gap-8 w-full">
        <h3 className="text-lg font-medium text-center pb-4 border-b">
          Transfer Ownership{" "}
        </h3>
        {mobileView === "outlet-side" && (
          <TransferOutlet
            outletType={outletType}
            setOutletType={setOutletType}
            selectedoutlet={selectedoutlet}
            setSelectedOutlet={setSelectedOutlet}
            restaurantName={restaurantName}
            setRestaurantName={setRestaurantName}
            storeName={storeName}
            setStoreName={setStoreName}
          />
        )}
        {mobileView === "business-side" && (
          <TransferBusiness
            outletType={outletType}
            selectedoutlet={selectedoutlet}
            selectedBusiness={selectedBusiness}
            setSelectedBusiness={setSelectedBusiness}
            businessName={businessName}
            setBusinessName={setBusinessName}
            businessDetails={businessDetails}
            setBusinessDetails={setBusinessDetails}
          />
        )}

        {/* Button for the outlet side for transfer ownership  */}
        {mobileView === "outlet-side" && (
          <div className="flex justify-center">
            {outletType !== "" &&
              (selectedoutlet?.restaurant_name ||
                selectedoutlet?.store_name) && (
                <Button.Primary
                  type={"button"}
                  onClick={() => setMobileview("business-side")}
                  title={"Next"}
                  className="px-6"
                />
              )}
          </div>
        )}
        {/* Button for the business side for transfer ownership  */}
        {mobileView === "business-side" && (
          <div className="flex justify-between">
            {outletType !== "" &&
              (selectedoutlet?.restaurant_name ||
                selectedoutlet?.store_name) && (
                <Button.Primary
                  type={"button"}
                  onClick={() => setMobileview("outlet-side")}
                  title={"Back"}
                  className="px-6"
                />
              )}
            <div>
              {businessName !== "" &&
                selectedBusiness?.business_name &&
                outletType === "restaurant" && (
                  <Button.Primary
                    type={"button"}
                    disabled={transferringRestaurant}
                    onClick={() => handleTransferRestaurant()}
                    title={
                      transferringRestaurant ? <Beat /> : "Transfer Ownership"
                    }
                  />
                )}
              {businessName !== "" &&
                selectedBusiness?.business_name &&
                outletType === "store" && (
                  <Button.Primary
                    type={"button"}
                    disabled={transferringStore}
                    onClick={() => handleTransferStore()}
                    title={transferringStore ? <Beat /> : "Transfer Ownership"}
                  />
                )}
            </div>
          </div>
        )}
      </div>

      {/* This view is strictly web view */}
      <div className="hidden sm:grid grid-cols-1 sm:grid-cols-12 gap-8">
        {/* Grid 1 */}
        <div className="sm:col-span-6 h-full">
          <div className="py-3 h-full bg-white dark:bg-[#121212]">
            <h3 className="text-lg font-medium text-center pb-4 border-b">
              Transfer Ownership{" "}
            </h3>

            <TransferOutlet
              outletType={outletType}
              setOutletType={setOutletType}
              selectedoutlet={selectedoutlet}
              setSelectedOutlet={setSelectedOutlet}
              restaurantName={restaurantName}
              setRestaurantName={setRestaurantName}
              storeName={storeName}
              setStoreName={setStoreName}
            />
          </div>
        </div>
        {/* Grid 2 */}
        <div className="sm:col-span-6 h-full">
          <div className="py-3 h-full bg-white dark:bg-[#121212]">
            <h3 className="text-lg font-medium text-center pb-4 border-b">
              Transfer Ownership{" "}
            </h3>
            <TransferBusiness
              outletType={outletType}
              selectedoutlet={selectedoutlet}
              selectedBusiness={selectedBusiness}
              setSelectedBusiness={setSelectedBusiness}
              businessName={businessName}
              setBusinessName={setBusinessName}
              businessDetails={businessDetails}
              setBusinessDetails={setBusinessDetails}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
